export default __webpack_public_path__ + "static/media/picture_about_banner02.ce629b05.png";